module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"label":"View reviews by product option","description":"*The number of reviews shown may differ from the actual count depending on the time of calculation."}}')
  delete Component.options._Ctor
}
